module.exports = __webpack_public_path__ + "5ce1ef68b8abcefcfacff88cda2bad66.svg";